import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type GetScheduledContentQueryVariables = Types.Exact<{
  contentType?: Types.Maybe<Types.ScheduledContentType>;
  forTime?: Types.Maybe<Types.Scalars['DateTime']>;
  uuid?: Types.Maybe<Types.Scalars['UUID']>;
}>;


export type GetScheduledContentQuery = (
  { __typename?: 'Query' }
  & { scheduledContent?: Types.Maybe<(
    { __typename?: 'ScheduledContentNode' }
    & Pick<Types.ScheduledContentNode, 'uuid' | 'contentType' | 'startTime' | 'bannerTitle' | 'bannerContent' | 'bannerCtaText' | 'bannerImage' | 'headerImage' | 'accentColor' | 'titleColor' | 'fullContent' | 'linkHeader'>
    & { scheduledContentLinks: Array<(
      { __typename?: 'ScheduledContentLinkNode' }
      & Pick<Types.ScheduledContentLinkNode, 'uuid' | 'image' | 'index' | 'title' | 'subtitle' | 'linkType' | 'mobileValue' | 'webValue' | 'isCta'>
    )>, myActivity?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'ScheduledContentActivityNode' }
      & Pick<Types.ScheduledContentActivityNode, 'activityType'>
    )>>> }
  )> }
);


export const GetScheduledContentDocument = gql`
    query getScheduledContent($contentType: ScheduledContentType, $forTime: DateTime, $uuid: UUID) {
  scheduledContent(contentType: $contentType, forTime: $forTime, uuid: $uuid) {
    uuid
    contentType
    startTime
    bannerTitle
    bannerContent
    bannerCtaText
    bannerImage
    headerImage
    accentColor
    titleColor
    fullContent
    linkHeader
    scheduledContentLinks {
      uuid
      image
      index
      title
      subtitle
      linkType
      mobileValue
      webValue
      isCta
    }
    myActivity {
      activityType
    }
  }
}
    `;
export type GetScheduledContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetScheduledContentQuery, GetScheduledContentQueryVariables>, 'query'>;

    export const GetScheduledContentComponent = (props: GetScheduledContentComponentProps) => (
      <ApolloReactComponents.Query<GetScheduledContentQuery, GetScheduledContentQueryVariables> query={GetScheduledContentDocument} {...props} />
    );
    
export type GetScheduledContentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetScheduledContentQuery, GetScheduledContentQueryVariables>
    } & TChildProps;
export function withGetScheduledContent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetScheduledContentQuery,
  GetScheduledContentQueryVariables,
  GetScheduledContentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetScheduledContentQuery, GetScheduledContentQueryVariables, GetScheduledContentProps<TChildProps, TDataName>>(GetScheduledContentDocument, {
      alias: 'getScheduledContent',
      ...operationOptions
    });
};

/**
 * __useGetScheduledContentQuery__
 *
 * To run a query within a React component, call `useGetScheduledContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledContentQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      forTime: // value for 'forTime'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetScheduledContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScheduledContentQuery, GetScheduledContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetScheduledContentQuery, GetScheduledContentQueryVariables>(GetScheduledContentDocument, options);
      }
export function useGetScheduledContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScheduledContentQuery, GetScheduledContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetScheduledContentQuery, GetScheduledContentQueryVariables>(GetScheduledContentDocument, options);
        }
export type GetScheduledContentQueryHookResult = ReturnType<typeof useGetScheduledContentQuery>;
export type GetScheduledContentLazyQueryHookResult = ReturnType<typeof useGetScheduledContentLazyQuery>;
export type GetScheduledContentQueryResult = ApolloReactCommon.QueryResult<GetScheduledContentQuery, GetScheduledContentQueryVariables>;